import NavProfile from './NavProfile.vue';

// @ts-ignore
NavProfile.install = (Vue) => {
  Vue.component((NavProfile as any).options.name, NavProfile);
};

export default NavProfile;
